import React, { useState } from "react";
import { Table } from "react-bootstrap";
import "./FormBank.css";
import CustomRadioExample from "./Components/CustomCheckExample";

const FormBankMoreBanks = (props) => {
  const [selectedTax, setSelectedTax] = useState({});

  const handleRadioChange = (radioId, category) => {
    setSelectedTax((prev) => {
      const currentSelected = prev[props.id];
      const newSelection = currentSelected === radioId ? "" : radioId;

      if (props.onSelect) {
        props.onSelect(newSelection, category);
      }

      return {
        ...prev,
        [props.id]: newSelection,
      };
    });
  };

  const taxPrivateItau = "12.09%"; // id 29
  const taxPersonnalite4e5Itau = "12.19%"; // id 27
  const taxPersonnalite1e3Itau = "12.39%"; // id 5
  const taxUniclass4e5Itau = "12.69%"; // id 28
  const taxUniclass1e3Itau = "13.09%"; // id 18
  const taxBalcaoItau = "13.69%"; // id 19

  const groupName = "bankOptions";

  return (
    <div className="table-container">
      <Table bordered responsive>
        <tbody>
          <tr>
            <td rowSpan="2" style={{ verticalAlign: "middle", width: "13%" }}>
              <div>
                <img
                  src="./assets/itau.svg"
                  alt="Ícone Itaú"
                  height="25%"
                  width="30%"
                />
              </div>
            </td>

            <td style={{ width: "25%" }}>
              <label
                htmlFor={29}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                {" "}
                <CustomRadioExample
                  id="29"
                  name={groupName}
                  label="Private"
                  checked={selectedTax[props.id] === "29"}
                  onClick={() => handleRadioChange("29")}
                />
                <span className="tax-badge">{taxPrivateItau}</span>
              </label>
            </td>

            <td style={{ width: "25%" }}>
              <label
                htmlFor={27}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                {" "}
                <CustomRadioExample
                  id="27"
                  name={groupName}
                  label="Personnalité 4 a 5"
                  checked={selectedTax[props.id] === "27"}
                  onClick={() => handleRadioChange("27")}
                />
                <span className="tax-badge">{taxPersonnalite4e5Itau}</span>
              </label>
            </td>

            <td style={{ width: "25%" }}>
              <label
                htmlFor={5}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                {" "}
                <CustomRadioExample
                  id="5"
                  name={groupName}
                  label="Personnalité 1 a 3"
                  checked={selectedTax[props.id] === "5"}
                  onClick={() => handleRadioChange("5")}
                />
                <span className="tax-badge">{taxPersonnalite1e3Itau}</span>
              </label>
            </td>
          </tr>

          <tr>
            <td>
              <label
                htmlFor={28}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                {" "}
                <CustomRadioExample
                  id="28"
                  name={groupName}
                  label="Uniclass 4 a 5"
                  checked={selectedTax[props.id] === "28"}
                  onClick={() => handleRadioChange("28")}
                />
                <span className="tax-badge">{taxUniclass4e5Itau}</span>
              </label>
            </td>

            <td>
              <label
                htmlFor={18}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                <CustomRadioExample
                  id="18"
                  name={groupName}
                  label="Uniclass 1 a 3"
                  checked={selectedTax[props.id] === "18"}
                  onClick={() => handleRadioChange("18")}
                />
                <span className="tax-badge">{taxUniclass1e3Itau}</span>
              </label>
            </td>

            <td>
              <label
                htmlFor={19}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                <CustomRadioExample
                  id="19"
                  name={groupName}
                  label="Conta Comum"
                  checked={selectedTax[props.id] === "19"}
                  onClick={() => handleRadioChange("19")}
                />
                <span className="tax-badge">{taxBalcaoItau}</span>
              </label>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default FormBankMoreBanks;
